/**
 * Created by Ning Jiang on 11/24/2022.
 */

import {TimelineLite} from "gsap";
import {GSAPBezierSpline} from "./GSAPBezierSpline";

export class AnimatedMeshRope extends PIXI.SimpleRope {

    private _textures:PIXI.Texture[] = [];
    private _tl:TimelineLite;
    private _totalFrames:number;
    private _totalDuration:number;
    private _frameDuration:number;

    private _currentFrame:number;

    constructor(textures:PIXI.Texture[], pointsData:PIXI.IPointData[], tps:number = 15) {
        super(textures[0], GSAPBezierSpline.interpolate(pointsData));

        this._currentFrame = 0;
        this._textures = textures;
        this._totalFrames = this._textures.length;
        this._totalDuration = this._textures.length / tps;
        this._frameDuration = this._totalDuration / this._textures.length;
    }

    public playAnimation():TimelineLite {
        this._tl = new TimelineLite();

        for(let i:number = 1; i < this._totalFrames; i++) {
            const duration = i * this._frameDuration;
            this._tl.add(() => {this.updateTexture();}, duration);
        }
        this._tl.add(() => this.onRemove());

        return this._tl;
    }

    private updateTexture():void {
        this._currentFrame++;
        this.texture = this._textures[this._currentFrame];
    }

    public onRemove():void {
        if(this._tl && this._tl.isActive()) {
            this._tl.pause();
            this._tl.kill();
        }
        if(this.transform) {
            if(this.parent) {
                this.parent.removeChild(this);
            }
            this.destroy();
        }
    }
}